import React, { useState } from 'react';

const ToggleSwitch = ({textDisabled, textEnabled, onEnabled}) => {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="flex items-center justify-center text-sm">
      <label className={`mr-2 ${!enabled ? 'text-black' : 'text-gray-400'}`}>
        {textEnabled}
      </label>
      <div className={`relative w-10 h-6 rounded-full ${enabled ? 'bg-gray-600' : 'bg-gray-300'}` } onClick={() => {
          if(onEnabled) onEnabled(!enabled)
          setEnabled(!enabled)          
        }}>
        <div
          className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-300 ease-in-out ${enabled ? 'transform translate-x-4' : ''
            }`}
        />
      </div>
      <label className={`ml-2 ${enabled ? 'text-black' : 'text-gray-400'}`}>
        {textDisabled}
      </label>
    </div>
  );
};

export default ToggleSwitch;
